exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-card {\n  border: 1px solid #ccc;\n  text-align: center;\n  margin-left: 5px;\n  width: 90%;\n  height: 28px;\n  background: #f1f1f1;\n  border-radius: 5px;\n}\n.input-card-border {\n  border: none !important;\n}\n.input-monthly {\n  border: 1px solid #fff;\n  text-align: center;\n  margin-left: 5px;\n  width: 30px;\n  background: #fff;\n  border-radius: 5px;\n  margin-right: 5px;\n}\n.input-left {\n  margin-right: 15px;\n}\n", ""]);

// exports
